import * as R from 'ramda'
import service from '@/service'

/**
 * This mixin contains some of the helper functions related to google spreadsheets
 */
export default {
  methods: {
    async lookupCellValue(orgId, spreadsheetUrl, sheetTitle, cell, externalAuthId) {
      const response = await service.client.get(`/exts/${orgId}/google_spreadsheets/lookup/`, {
        params: {
          spreadsheet_url: encodeURI(spreadsheetUrl),
          sheet_title: sheetTitle,
          cell: cell,
          external_auth_id: externalAuthId
        }
      })
      let rawValue = R.path(['data', 'values', '0', '0'], response)
      if (typeof rawValue === 'string') {
        rawValue = rawValue.replace(/[$,]/g, '')
      }
      return parseFloat(rawValue)
    },
    async getLinkInfo(orgId, krId) {
      const response = await service.client.get(`/exts/${orgId}/google_spreadsheets/links/${krId}/`)
      return response.data
    },
    async getCurrentValue(kr) {
      const {
        spreadsheetTitle,
        sheetTitle,
        spreadsheetUrl,
        cell,
        externalAuthId
      } = await this.getLinkInfo(kr.organizationId, kr.id)
      try {
        const newCurrent = await this.lookupCellValue(
          kr.organizationId,
          spreadsheetUrl,
          sheetTitle,
          cell,
          externalAuthId
        )
        if (Number.isNaN(newCurrent)) {
          return { errors: ['Invalid value fetched'] }
        } else {
          return { value: newCurrent, spreadsheetUrl, spreadsheetTitle, sheetTitle, cell }
        }
      } catch (e) {
        const errorMessage = R.pathOr('Error while fetching', ['response', 'data', 'message'], e)
        return { errors: [errorMessage] }
      }
    }
  }
}
